import { render, staticRenderFns } from "./ListStudents.vue?vue&type=template&id=0613c54e&scoped=true&"
import script from "./ListStudents.vue?vue&type=script&lang=js&"
export * from "./ListStudents.vue?vue&type=script&lang=js&"
import style0 from "./ListStudents.vue?vue&type=style&index=0&id=0613c54e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0613c54e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataFooter } from 'vuetify/lib/components/VDataIterator';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VDataFooter,VDataTable,VResponsive})
